import { ChangeDetectionStrategy, Component } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { ButtonModule, DialogModule, DialogRef, DialogService } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  templateUrl: "./clear-generator-history-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule, I18nPipe],
  host: {
    class: "bv-clear-generator-history-dialog-host",
  },
})
export class ClearGeneratorHistoryDialogComponent {
  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  protected close(result: boolean): void {
    void this.dialogRef.close(result);
  }

  static open(dialogService: DialogService): Promise<boolean> {
    const dialogRef = dialogService.open<boolean>(ClearGeneratorHistoryDialogComponent, {});
    return firstValueFrom(dialogRef.closed).then((result) => result ?? false);
  }
}
